export default "__VITE_ASSET__f3717a61__"